import type { FaireProductEntity } from "../../entity_types/product";

export const p_2gnt96b999: FaireProductEntity = {
  token: "p_2gnt96b999",
  type: "product",
  name: "Lily of the Valley Sympathy Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a6361a6fc7c76f0d0b2ad10e0d4cd726d1cda4333796eb9b244f4d4043b03379.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe0b004bca4d316de2203d005ab4b9bbeaf2b19b1ee2461aaa57d5d505dd7eba.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description: "Rich, sad and beautiful. Like some chapters of life.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:23.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
